import { batch, connect } from 'react-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { updateFilters, UpdateFiltersActionType } from 'src/redux/products';
import { AppThunkDispatch } from 'src/redux/store';
import { actions as filterMenuActions } from '../../FilterMenu/modules/slice';
import { FilterList } from '../components/FilterList';
import { onViewResultsClick } from '../modules/actions';
import {
  selectFiltersWithFilterOptionsCount,
  selectTotalSelectedFilterOptionsCount,
} from '../modules/selectors';
import { actions as filterActions } from '../modules/slice';

export const mapStateToProps = (state: ReduxApplicationState) => ({
  isLoading: state.products.isLoading,
  filters: selectFiltersWithFilterOptionsCount(state),
  totalProducts: state.products.totalProducts,
  totalSelectedFilterOptionsCount: selectTotalSelectedFilterOptionsCount(state),
  error: state.products.error,
});

export const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  onCloseFilters: () => dispatch(filterActions.closeModal()),
  onViewResults: () => {
    batch(() => {
      dispatch(onViewResultsClick());
      dispatch(filterActions.closeModal());
    });
  },
  onResetFilters: () => {
    batch(() => {
      dispatch(filterActions.resetFilters());
      dispatch(filterMenuActions.resetSelectedSortOption());
      dispatch(updateFilters(UpdateFiltersActionType.FILTER));
    });
  },
});

export const FilterListContainer = connect(mapStateToProps, mapDispatchToProps)(FilterList);
